import HandleRedirect from './HandleRedirect';
import shouldRedirect from './shouldRedirect';

const GladeRedirectProvider: React.FC = ({ children }) => {
  if (!shouldRedirect()) {
    return (<>{children}</>);
  }
  return <HandleRedirect />;
};

export default GladeRedirectProvider;